export const TANISH_WEBSITE_AI_REVIEW_URL = "https://tanishtextiles.co.in/review";